import createAction from '../../../utils/redux-helpers/createAction';

const handler = (state, { value }) =>
  state.setIn(['customer', 'callToDriver'], value);

export const toggleCallTo = createAction({
  action: ['toggleCallTo', 'value'],
  handler,
});
